import styled from 'styled-components';

export default styled.input`
  border: 1px solid #9599a3;
  color: #515151;
  font-size: 1rem;
  padding: 0.75em;
  width: 100%;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, padding 0.15s ease-in-out, box-shadow 0.15s ease-in-out, transform 0.15s ease-in-out;

  &::placeholder {
    color: #d6d9df;
  }

  &:hover {
    border-color: #c3e2f5;
  }

  &:focus {
    border-color: #118bd6;
    box-shadow: 0 0 0 0.2em rgba(17, 139, 214, 0.25);
    outline: none;
  }

  ${({ theme, touched, invalid }) =>
    touched &&
    invalid &&
    `
      border-color: ${theme.colors.negative};

      &:hover {
        border-color: ${theme.colors.negative_bg};
      }

      &:focus {
        border-color: ${theme.colors.negative_bg};
        box-shadow: 0 0 0 0.2em rgb(207 20 43 / 25%);
      }
  `}
;`